import React from 'react';
import styled from 'styled-components';

import Loading from 'core/Loading';

import { Benefits } from '../components/Benefits';
import { Disclaimer } from '../components/Disclaimer';
import { HeroHeader } from '../components/HeroHeader';
import { HowItWorks } from '../components/HowItWorks';
import { Metrics } from '../components/Metrics';
import { MonthSelector } from '../components/MonthSelector';
import { StatusBanner } from '../components/StatusBanner';
import { TopTips } from '../components/TopTips';
import { useBestOfWoltData } from '../hooks/useBestOfWoltData';
import { RelativeMonth } from '../types';

type IndexPageProps = {
  venueId: string;
  venueTimezone: string;
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  padding: 24px;
`;

const StyledLoadingContainer = styled.div`
  display: flex;
  align-self: stretch;
  justify-content: center;
`;

export const IndexPage = ({ venueId, venueTimezone }: IndexPageProps) => {
  const [activeRelativeMonth, setActiveRelativeMonth] = React.useState<RelativeMonth>(RelativeMonth.NEXT_MONTH);

  const { relativeDate, data, isLoading } = useBestOfWoltData({
    venueId,
    venueTimezone,
    relativeMonth: activeRelativeMonth,
  });

  return (
    <>
      <PageContainer>
        <HeroHeader />
        <MonthSelector activeRelativeMonth={activeRelativeMonth} setActiveRelativeMonth={setActiveRelativeMonth} />
        {isLoading && (
          <StyledLoadingContainer>
            <Loading />
          </StyledLoadingContainer>
        )}
        {data?.data && !isLoading && (
          <>
            <StatusBanner
              calculationResult={data.data.calculationStatus}
              relativeDate={relativeDate}
              startDate={data.startDate}
              endDate={data.endDate}
              timezone={venueTimezone}
            />
            {<Metrics metrics={data.data.goals} />}
          </>
        )}
        <HowItWorks />
        <Benefits />
        <TopTips />
        <Disclaimer />
      </PageContainer>
    </>
  );
};
